import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { Modal, ModalBody } from "reactstrap";

class CardModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      card: this.props.cardNumber || "",
    };
  }

  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.props.cardModal}
          toggle={() => this.props.changeModal(!this.props.cardModal)}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 px-0">
              <p className="fw-bold fs-4">تنظیمات واریز به کارت</p>
              <p className="fw-bold small text-muted mb-4">
                ثبت / تغییر شماره کارتی که به خریداران برای واریز وجه سفارشات
                نمایش داده می شود.
              </p>
            </div>
            <div
              className={`col-12 px-0 position-relative rounded14 p-3 ${
                this.props.cardError ? "border border-danger" : "border-main-1"
              }`}
            >
              <NumberFormat
                value={this.state.card}
                onValueChange={(values) => {
                  this.setState({ card: values.value });
                }}
                placeholder="----   ----   ----   ----"
                format="####   ####   ####   ####"
                mask="-"
                dir="ltr"
                onBlur={(e) =>
                  e.target.value.replace(/ |-/gi, "").length !== 16
                    ? e.target.classList.add("text-danger")
                    : e.target.classList.remove("text-danger")
                }
                className="w-100 h-100 p-0 fs-5 border-0 fw-bold border-0 text-center"
              />

              {this.state.card && (
                <span
                  className="position-absolute fs-7 color-main bg-white px-2"
                  style={{ top: "-8px", right: "20px" }}
                >
                  شماره کارت
                </span>
              )}
            </div>
            {this.props.cardError && (
              <span className="text-danger small pe-3 mt-2">
                {this.props.cardError[0].message}
              </span>
            )}
            <div className="col-12 px-0 mt-3">
              <button
                disabled={this.state.card.length !== 16}
                onClick={() => this.props.cardNumberChange(this.state.card)}
                className="btn bg-color-main bg-disabled text-white fw-bold py-2-3 w-100 rounded28"
              >
                ثبت
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default CardModal;
